import React from 'react';
import { Lightbulb, CheckCircle, AlertCircle, Users, Target } from 'lucide-react';

const BestPracticesPanel = () => {
  const practices = [
    {
      icon: CheckCircle,
      title: 'Utilisez des titres descriptifs',
      description: 'Nommez vos liens de façon claire pour faciliter le suivi',
      type: 'tip'
    },
    {
      icon: Target,
      title: 'Paramètres UTM cohérents',
      description: 'Gardez une nomenclature consistente pour vos campagnes',
      type: 'tip'
    },
    {
      icon: Users,
      title: 'QR codes pour événements',
      description: 'Les QR codes sont parfaits pour les affiches et supports physiques',
      type: 'tip'
    },
    {
      icon: AlertCircle,
      title: 'Testez vos liens',
      description: 'Vérifiez toujours que vos liens fonctionnent avant diffusion',
      type: 'warning'
    }
  ];

  const socialPlatformTips = [
    {
      platform: 'Instagram',
      tips: ['Utilisez QR codes en Story', 'Lien en bio optimisé', 'UTM: instagram/social']
    },
    {
      platform: 'Facebook',
      tips: ['Posts avec call-to-action', 'Événements Facebook', 'UTM: facebook/social']
    },
    {
      platform: 'Email',
      tips: ['Texte du lien explicite', 'UTM distinctif', 'UTM: newsletter/email']
    }
  ];

  return (
    <div className="space-y-6">
      {/* Best Practices */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Lightbulb className="h-5 w-5 text-yellow-500" />
          <h3 className="text-lg font-medium text-gray-900">
            Bonnes pratiques
          </h3>
        </div>
        
        <div className="space-y-4">
          {practices?.map((practice, index) => {
            const IconComponent = practice?.icon;
            return (
              <div
                key={index}
                className={`p-3 rounded-lg border ${
                  practice?.type === 'warning' ?'border-yellow-200 bg-yellow-50' :'border-green-200 bg-green-50'
                }`}
              >
                <div className="flex items-start space-x-3">
                  <IconComponent className={`h-4 w-4 mt-0.5 ${
                    practice?.type === 'warning' ? 'text-yellow-600' : 'text-green-600'
                  }`} />
                  <div className="flex-1">
                    <h4 className="text-sm font-medium text-gray-900">
                      {practice?.title}
                    </h4>
                    <p className="text-xs text-gray-600 mt-1">
                      {practice?.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Social Platform Integration */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Intégration sociale
        </h3>
        
        <div className="space-y-4">
          {socialPlatformTips?.map((social, index) => (
            <div key={index} className="border-l-4 border-indigo-200 pl-4">
              <h4 className="text-sm font-medium text-gray-900 mb-2">
                {social?.platform}
              </h4>
              <ul className="space-y-1">
                {social?.tips?.map((tip, tipIndex) => (
                  <li key={tipIndex} className="text-xs text-gray-600 flex items-start">
                    <span className="w-1 h-1 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"></span>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* Quick Stats */}
      <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg p-6 text-white">
        <h3 className="text-lg font-medium mb-4">
          Optimisez vos performances
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm">QR codes</span>
            <span className="text-sm font-medium">+340% engagement</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm">UTM tracking</span>
            <span className="text-sm font-medium">+250% insights</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm">Liens courts</span>
            <span className="text-sm font-medium">+180% partages</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestPracticesPanel;